import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router ,NavigationEnd} from '@angular/router';
import { AppTokenHandler } from '../common/app-token-handler';
import { Location } from '@angular/common';
import { StartupPopupComponent } from '../out-of-application/startup-popup/startup-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { Global } from '../Global';
import { DataService } from '../common/data.service';

// import { environment } from 'src/environments/environment.prod';
// import { environment } from 'src/environments/environment.test';

import { environment } from 'src/environments/environment';
import { AppInsightsService } from './app-insights.service';
import { LoginService } from './login.service.azure';
@Injectable()
export class AuthGuardService implements CanActivate {
    isRole = false;
    userDetails: any;
    roleList: string[];
    href: string;

    constructor(private router: Router, private appToken: AppTokenHandler,
        private dddd: MatDialog, private route: Router, private location: Location,
        private _global: Global,private loginService: DataService,
        private appInsightsService: AppInsightsService,
        private loginserviceazure : LoginService
) {

            this.router.events.forEach((event) => {
                if (event instanceof NavigationEnd) {
                    this.LogPageAnalytics();
                    //alert('djsjs');
                }
            });
    }
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        this.loginserviceazure.redirectUrl = state.url;
 
         sessionStorage.setItem('redirectUrl', state.url);
 
        const expectedRole = next.data.expectedRole;
        if (this.appToken.getLoginUserInfo() == null) {
            this.href = this.location.path();
            this.router.navigate(['/login']);
        } else {
            this.userDetails = this.appToken.getLoginUserInfo();
            if (this.userDetails === null) {
                this.isRole = false;
            } else {
                this.isRole = false;
                this.roleList = this.userDetails.Roles.split(',');
                expectedRole.forEach(element => {
                    if (this.roleList.indexOf(element) >= 0) {
                        this.isRole = true;
                    }
                });
            }
            if (!this.isRole) {
                this.router.navigate(['/error/4']);
                return false;
            } else {
                this._global.IsConsent = this.appToken.getLoginUserInfo().IsConsent;
                if (this._global.IsConsent === false) {
                    setTimeout(() => {
                        this.openAssetServiceDetailsModel(StartupPopupComponent);
                    });
                }
                return true;
            }
        }
    }

    openAssetServiceDetailsModel(templateRef) {
        const dialogRef = this.dddd.open(templateRef, {
            width: '950px',
            height: '585px',
            disableClose: true
        });
        dialogRef.afterClosed().subscribe(result => {
        });
    }

    // LogPageAnalytics() {
    //     // if (environment.logPageAnalytics == 'Y') {
    //     //    // alert('83883');
    //     //     this.loginService
    //     //         .LogPageAnalytics(environment.pageAnalyticsUrl + '?PageTitle=' + window.location.href.replace('#/', '') + '&ApplicationCode=ITRecovery')
    //     //         .subscribe(data => {
    //     //             //alert('ok');

    //     //     }, (error) => {
    //     //         //alert(error);
    //     //     });
    //     // }
    // }

    LogPageAnalytics() {   
        let IsAzureLogAppInsights = false;
               let UserInfo = this.appToken.getLoginUserInfo();
               if (UserInfo != null && UserInfo.isAzureLogAppInsights != null) {
                IsAzureLogAppInsights = UserInfo.isAzureLogAppInsights;
               }
               if (IsAzureLogAppInsights) {
                   const username = UserInfo.EmpGPN; // Replace with actual username retrieval logic
                   this.appInsightsService.trackPageView(window.location.href.replace('#/', ''), username);
               }
           }

}
